import { TmapApp } from '@tmap-web-lib/tmap-app-interface'

import { isClient } from '@/utils/compare'

type Restore = () => void

export const bodyScrollLock = (): Restore => {
  const { pageYOffset } = window

  const restoreScroll = pageYOffset
  const restoreStyle = [{
    property: 'overflow',
    value: document.body.style.overflow,
  }, {
    property: 'width',
    value: document.body.style.width,
  }, {
    property: 'position',
    value: document.body.style.position,
  }, {
    property: 'top',
    value: document.body.style.top,
  }]

  const currentTop = parseInt(document.body.style.top, 10)
  const top = currentTop < 0 ? currentTop : pageYOffset * -1

  document.body.style.overflow = 'hidden'
  document.body.style.width = '100%'
  document.body.style.position = 'fixed'
  document.body.style.top = `${top}px`
  window.scrollTo(0, 0)

  const restore = () => {
    restoreStyle.forEach(({ property, value }) => {
      if (value) {
        document.body.style.setProperty(property, value)
      }
      else {
        document.body.style.removeProperty(property)
      }
    })
    window.scrollTo(0, restoreScroll)

    if (TmapApp.env.isInApp && TmapApp.env.isIOS && isClient) {
      // iOS(26 포함)에서 body position:fixed 해제 시 viewport 계산이 갱신되지 않아
      // 이미 마운트되어 있던 다른 position:fixed 요소(예: Header)가 잘못된 위치로
      // 페인트된 채 남는 버그 대응. dispatchEvent(scroll)은 등록된 리스너만 호출할
      // 뿐 실제 리플로우를 유발하지 않으므로, TMAPWEB-2121에서 검증된 것과 동일하게
      // 실제 스크롤 좌표를 변경해 강제로 리플로우를 발생시킨다.
      window.scrollTo({ left: 1 })
    }
  }

  return restore
}
